"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _materialSymbols = require("@design/icons/material-symbols");
var _card = require("@design/ui/card");
var _reactMarkdown = _interopRequireDefault(require("react-markdown"));
var _rehypeRaw = _interopRequireDefault(require("rehype-raw"));
var _rehypeSanitize = _interopRequireDefault(require("rehype-sanitize"));
var _remarkGfm = _interopRequireDefault(require("remark-gfm"));
var _utils = require("@design/lib/utils");
var _tools = require("../../constants/tools");
var _elapsed = require("./elapsed");
var _toolStepDisplay = require("./toolStepDisplay");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _toConsumableArray(r) { return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray(r) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(r) { if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r); }
function _arrayWithoutHoles(r) { if (Array.isArray(r)) return _arrayLikeToArray(r); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; } /** How a failed step reads: "report" shows a red dot and the backend's message, "neutral" a grey dot and nothing to expand. */ /** Shape of an entry inside a sub-agent's mini-chat. Mirrors the relevant
 * subset of `GroupableMessage` produced by `toInnerMessages`. */
var SETTLED_OR_RUNNING_STEP_DOT_COLOR = {
  in_progress: "border border-border-input border-t-transparent animate-spin",
  interrupted: "bg-warning-strong",
  done: "bg-success-strong"
};
function StepDot(_ref) {
  var colorClass = _ref.colorClass,
    className = _ref.className;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: (0, _utils.cn)("w-1.5 h-1.5 rounded-full shrink-0", colorClass, className),
    "aria-hidden": "true",
    "data-sentry-component": "StepDot",
    "data-sentry-source-file": "ToolCallGroup.tsx"
  });
}
var MARKDOWN_BASE_CLASSES = (0, _utils.cn)("text-sm leading-relaxed text-foreground-primary", "[&_p]:my-1 [&_ul]:my-1 [&_ul]:list-disc [&_ul]:pl-5", "[&_ol]:my-1 [&_ol]:list-decimal [&_ol]:pl-5", "[&_li]:my-0.5", "[&_h1]:text-base [&_h1]:font-semibold [&_h1]:mt-2 [&_h1]:mb-1", "[&_h2]:text-sm [&_h2]:font-semibold [&_h2]:mt-2 [&_h2]:mb-1", "[&_h3]:text-sm [&_h3]:font-semibold [&_h3]:mt-1 [&_h3]:mb-1", "[&_code]:text-xs [&_code]:bg-background-subtle [&_code]:px-1 [&_code]:rounded", "[&_pre]:bg-background-subtle [&_pre]:p-2 [&_pre]:rounded [&_pre]:overflow-x-auto", "[&_pre_code]:bg-transparent [&_pre_code]:px-0", "[&_a]:text-primary [&_a]:underline hover:[&_a]:text-background-primary-hover", "[&_blockquote]:border-l-2 [&_blockquote]:border-border-default [&_blockquote]:pl-3 [&_blockquote]:text-foreground-muted",
// Table styling — wrapped in an overflow-x-auto box so wide tables can
// scroll horizontally without breaking the mini-chat layout.
"[&_table]:block [&_table]:w-full [&_table]:overflow-x-auto", "[&_table]:my-2 [&_table]:border [&_table]:border-border-default [&_table]:rounded", "[&_table]:border-collapse [&_table]:text-xs", "[&_thead]:bg-background-subtle", "[&_th]:border [&_th]:border-border-default [&_th]:px-2 [&_th]:py-1 [&_th]:text-left [&_th]:font-semibold", "[&_td]:border [&_td]:border-border-default [&_td]:px-2 [&_td]:py-1 [&_td]:align-top");
function StepMarkdown(_ref2) {
  var content = _ref2.content;
  // Used for tool result expansion bodies (search_repository, perplexity, …).
  // Constrained to 300px with internal scroll so a long result doesn't blow
  // up the parent group card.
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _utils.cn)(MARKDOWN_BASE_CLASSES, "max-h-[300px] overflow-y-auto overscroll-contain"),
    "data-sentry-component": "StepMarkdown",
    "data-sentry-source-file": "ToolCallGroup.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
      rehypePlugins: [_rehypeRaw.default, _rehypeSanitize.default],
      remarkPlugins: [_remarkGfm.default],
      "data-sentry-element": "Markdown",
      "data-sentry-source-file": "ToolCallGroup.tsx",
      children: content
    })
  });
}
function InnerChatBubble(_ref3) {
  var content = _ref3.content;
  // Used for the sub-agent's text responses inside the mini-chat. NO height
  // cap — the user wants to read the sub-agent's full reasoning, and the
  // outer chat container is already scrollable.
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: MARKDOWN_BASE_CLASSES,
    "data-sentry-component": "InnerChatBubble",
    "data-sentry-source-file": "ToolCallGroup.tsx",
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)(_reactMarkdown.default, {
      rehypePlugins: [_rehypeRaw.default, _rehypeSanitize.default],
      remarkPlugins: [_remarkGfm.default],
      "data-sentry-element": "Markdown",
      "data-sentry-source-file": "ToolCallGroup.tsx",
      children: content
    })
  });
}

// The synthetic messageType emitted by `groupAssistantSteps` for a tool
// group card. Duplicated here as a string literal to keep ToolCallGroup
// free of imports from the grouper (which itself imports types from us).
var TOOL_GROUP_MESSAGE_TYPE = "tool_group";
function InnerChat(_ref4) {
  var messages = _ref4.messages,
    compact = _ref4.compact,
    isStreaming = _ref4.isStreaming,
    isTurnOpen = _ref4.isTurnOpen,
    failedStepStyle = _ref4.failedStepStyle;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
    className: (0, _utils.cn)("flex flex-col", compact ? "gap-2" : "gap-3"),
    "data-sentry-component": "InnerChat",
    "data-sentry-source-file": "ToolCallGroup.tsx",
    children: messages.map(function (m, i) {
      var _m$id;
      var key = (_m$id = m.id) !== null && _m$id !== void 0 ? _m$id : "inner-".concat(i);
      if (m.messageType === TOOL_GROUP_MESSAGE_TYPE) {
        var artifacts = m.turnArtifacts;
        if (!(artifacts !== null && artifacts !== void 0 && artifacts.steps) || artifacts.steps.length === 0) return null;
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(ToolCallGroup, {
          steps: artifacts.steps,
          isStreaming: artifacts.isStreaming && isStreaming,
          isTurnOpen: artifacts.isStreaming && isTurnOpen,
          compact: compact,
          failedStepStyle: failedStepStyle
        }, key);
      }
      if (!m.content) return null;
      return /*#__PURE__*/(0, _jsxRuntime.jsx)(InnerChatBubble, {
        content: m.content
      }, key);
    })
  });
}
function StepRow(_ref5) {
  var step = _ref5.step,
    showConnector = _ref5.showConnector,
    compact = _ref5.compact,
    isStreaming = _ref5.isStreaming,
    isTurnOpen = _ref5.isTurnOpen,
    failedStepStyle = _ref5.failedStepStyle,
    chip = _ref5.chip,
    onUserInteract = _ref5.onUserInteract;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    isExpanded = _useState2[0],
    setIsExpanded = _useState2[1];
  var hasInnerMessages = !!step.innerMessages && step.innerMessages.length > 0;
  var hasMarkdownBody = !!step.resultContent && _tools.COLLAPSIBLE_TOOLS.has(step.toolName);
  var hasErrorBody = failedStepStyle === "report" && step.status === "error" && !!step.errorMessage;
  var isInterrupted = step.status === "interrupted";
  // Interrupted rows always expand — even if no innerMessages were captured —
  // so we can render the "Cancelled before producing output" fallback below.
  var isExpandable = hasInnerMessages || hasMarkdownBody || hasErrorBody || isInterrupted;
  var isInProgress = step.status === "in_progress";
  // Sub-agent steps stay clickable while in-progress so the user can peek
  // inside the mini-chat as it streams. Regular tool rows don't have anything
  // useful to show until the result arrives.
  var allowExpandWhileStreaming = hasInnerMessages;
  var canExpand = isExpandable && (allowExpandWhileStreaming || !isInProgress);
  var stepDotColorClass = step.status === "error" ? _toolStepDisplay.FAILED_STEP_PRESENTATION[failedStepStyle].colorClass : SETTLED_OR_RUNNING_STEP_DOT_COLOR[step.status];
  var label = isInProgress ? (0, _tools.getToolDisplayName)(step.toolName) : isInterrupted ? (0, _tools.getToolInterruptedName)(step.toolName) : step.status === "error" ? (0, _tools.getToolFailedName)(step.toolName, _toolStepDisplay.FAILED_STEP_PRESENTATION[failedStepStyle].outcome) : labelForCompletedTool(step.toolName);
  var textSize = compact ? "text-xs" : "text-sm";
  var subject = step.subject ? /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
    className: "font-normal text-foreground-muted",
    children: " \xB7 ".concat(step.subject)
  }) : null;
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
    children: [chip, /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
      className: (0, _utils.cn)("relative", textSize, "text-foreground-muted"),
      children: [showConnector &&
      /*#__PURE__*/
      // Dot lives at top:8, height 6 → occupies pixels 8..14. Start the
      // connector 2px below its bottom and end it 2px before the next dot
      // (next row's top + 8) so the line never passes *through* a dot —
      // critical for the in-progress spinner, whose ring is transparent.
      (0, _jsxRuntime.jsx)("div", {
        "aria-hidden": "true",
        className: "absolute w-[1px] bg-border-subtle left-[2.5px] top-[16px] h-full"
      }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        onClick: function onClick() {
          if (!canExpand) return;
          onUserInteract === null || onUserInteract === void 0 || onUserInteract();
          setIsExpanded(function (v) {
            return !v;
          });
        },
        disabled: !canExpand,
        className: (0, _utils.cn)("flex items-start w-full text-left", canExpand && "hover:text-foreground-primary cursor-pointer", !canExpand && "cursor-default"),
        "aria-expanded": canExpand ? isExpanded : undefined,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(StepDot, {
          colorClass: stepDotColorClass,
          className: "mt-2",
          "data-sentry-element": "StepDot",
          "data-sentry-source-file": "ToolCallGroup.tsx"
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "ml-2 min-w-0 flex-1 break-words font-medium",
          children: [label, subject]
        }), canExpand && /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
          className: (0, _utils.cn)("mt-2 ml-2 shrink-0 transition-transform duration-200", isExpanded ? "" : "-rotate-90")
        })]
      }), canExpand && isExpanded && /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
        className: "mt-2 ml-[14px]",
        children: [hasErrorBody && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-xs text-destructive-text mb-2 whitespace-pre-wrap break-words",
          children: step.errorMessage
        }), hasInnerMessages && /*#__PURE__*/(0, _jsxRuntime.jsx)(InnerChat, {
          messages: step.innerMessages,
          compact: compact,
          isStreaming: isStreaming,
          isTurnOpen: isTurnOpen,
          failedStepStyle: failedStepStyle
        }), hasMarkdownBody && !hasInnerMessages && /*#__PURE__*/(0, _jsxRuntime.jsx)(StepMarkdown, {
          content: step.resultContent
        }), isInterrupted && !hasInnerMessages && !hasMarkdownBody && !hasErrorBody && /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
          className: "text-xs text-warning-text italic",
          children: "Cancelled by user."
        })]
      })]
    })]
  });
}

/**
 * `TOOL_DISPLAY_NAMES` is present-tense ("Running sub-agent", "Reading
 * file..."); `TOOL_DONE_NAMES` has the matching past-tense label ("Sub-agent
 * finished", "File read"). Falling back to display-name minus trailing
 * ellipsis silently kept entries like "Running sub-agent" present-tense on
 * completion, since they had no `...` to strip.
 */
function labelForCompletedTool(toolName) {
  return (0, _tools.getToolDoneName)(toolName);
}
var ToolCallGroup = function ToolCallGroup(_ref6) {
  var _reverse$find;
  var steps = _ref6.steps,
    failedStepStyle = _ref6.failedStepStyle,
    isStreaming = _ref6.isStreaming,
    _ref6$isTurnOpen = _ref6.isTurnOpen,
    isTurnOpen = _ref6$isTurnOpen === void 0 ? false : _ref6$isTurnOpen,
    _ref6$compact = _ref6.compact,
    compact = _ref6$compact === void 0 ? false : _ref6$compact,
    renderStepChip = _ref6.renderStepChip;
  var active = isStreaming || isTurnOpen;
  // Open while streaming so the user can watch live progress; collapse the
  // moment the group finishes (or, on history load, render collapsed from
  // the start since `isStreaming` is always false). Once the user has
  // *interacted* with the group — either toggling its header chevron or
  // expanding any step row inside it — we latch `userEngaged` so the
  // auto-collapse never overrides what they chose to look at. (Expanding a
  // row counts because otherwise a sub-agent mini-chat the user opened to
  // peek at mid-stream would get yanked shut the instant the parent
  // finishes.)
  var _useState3 = (0, _react.useState)(false),
    _useState4 = _slicedToArray(_useState3, 2),
    userEngaged = _useState4[0],
    setUserEngaged = _useState4[1];
  var displaySteps = (0, _toolStepDisplay.resolveDisplaySteps)(steps, active);
  var stepChips = displaySteps.map(function (step) {
    var _renderStepChip;
    return (_renderStepChip = renderStepChip === null || renderStepChip === void 0 ? void 0 : renderStepChip(step.toolCallId)) !== null && _renderStepChip !== void 0 ? _renderStepChip : null;
  });
  var hostsChip = stepChips.some(Boolean);
  var _useState5 = (0, _react.useState)(active || hostsChip),
    _useState6 = _slicedToArray(_useState5, 2),
    isOpen = _useState6[0],
    setIsOpen = _useState6[1];
  (0, _react.useEffect)(function () {
    if (userEngaged) return;
    setIsOpen(active || hostsChip);
  }, [active, hostsChip, userEngaged]);
  var anyInterrupted = displaySteps.some(function (s) {
    return s.status === "interrupted";
  });
  var shouldUpdateElapsedTimer = active && !anyInterrupted;
  var now = (0, _elapsed.useLiveNow)(shouldUpdateElapsedTimer);
  var elapsedMs = (0, _toolStepDisplay.computeElapsedMs)(displaySteps, now);
  var elapsed = (0, _elapsed.formatElapsed)(elapsedMs);
  var failedStepCount = displaySteps.filter(function (s) {
    return s.status === "error";
  }).length;
  var label = (0, _toolStepDisplay.groupHeaderLabel)({
    anyInterrupted: anyInterrupted,
    isStreaming: isStreaming,
    isTurnOpen: isTurnOpen,
    stepCount: displaySteps.length,
    runningStep: (_reverse$find = _toConsumableArray(displaySteps).reverse().find(function (step) {
      return step.status === "in_progress";
    })) !== null && _reverse$find !== void 0 ? _reverse$find : null,
    failedStepCount: failedStepCount,
    failedStepStyle: failedStepStyle
  });
  var headerFailedStepDot = failedStepCount > 0 ? /*#__PURE__*/(0, _jsxRuntime.jsx)(StepDot, {
    colorClass: _toolStepDisplay.FAILED_STEP_PRESENTATION[failedStepStyle].colorClass,
    className: "mr-2"
  }) : null;
  var headerTextClass = compact ? "text-xs" : "text-sm";
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_card.Card, {
    size: "sm",
    className: "my-1 max-w-[95%]",
    "data-sentry-element": "Card",
    "data-sentry-component": "ToolCallGroup",
    "data-sentry-source-file": "ToolCallGroup.tsx",
    children: [/*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardHeader, {
      "data-sentry-element": "CardHeader",
      "data-sentry-source-file": "ToolCallGroup.tsx",
      children: /*#__PURE__*/(0, _jsxRuntime.jsxs)("button", {
        type: "button",
        onClick: function onClick() {
          setUserEngaged(true);
          setIsOpen(function (v) {
            return !v;
          });
        },
        className: (0, _utils.cn)("w-full flex items-center justify-between text-muted-foreground hover:text-foreground transition-colors", headerTextClass),
        "aria-expanded": isOpen,
        children: [/*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "flex items-center min-w-0",
          children: [headerFailedStepDot, /*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "truncate",
            children: label
          })]
        }), /*#__PURE__*/(0, _jsxRuntime.jsxs)("span", {
          className: "flex items-center gap-2 shrink-0 ml-3",
          children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("span", {
            className: "text-xs text-muted-foreground tabular-nums",
            "aria-label": "Elapsed time: ".concat(elapsed),
            children: elapsed
          }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_materialSymbols.KeyboardArrowDownIcon, {
            className: (0, _utils.cn)("transition-transform duration-200", isOpen ? "" : "-rotate-90"),
            "data-sentry-element": "KeyboardArrowDownIcon",
            "data-sentry-source-file": "ToolCallGroup.tsx"
          })]
        })]
      })
    }), isOpen && /*#__PURE__*/(0, _jsxRuntime.jsx)(_card.CardContent, {
      children: displaySteps.map(function (step, i) {
        return /*#__PURE__*/(0, _jsxRuntime.jsx)(StepRow, {
          step: step,
          showConnector: i < displaySteps.length - 1,
          compact: compact,
          isStreaming: isStreaming,
          isTurnOpen: isTurnOpen,
          failedStepStyle: failedStepStyle,
          chip: stepChips[i],
          onUserInteract: function onUserInteract() {
            return setUserEngaged(true);
          }
        }, step.toolCallId || "".concat(step.toolName, "-").concat(i));
      })
    })]
  });
};
var _default = exports.default = ToolCallGroup;